import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgDexpanthenolGlyphSecondary(props) {
  return jsx("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    d: "M40 30.02c0-5.86-2.37-9.22-6.5-9.22-3.96 0-6.29 3.09-6.48 8.5h-3.31c.38-1.28.6-2.62.6-3.99V22.7C24.31 14.78 17.54 8 12 8H8.75c-.41 0-.75.34-.75.75s.34.75.75.75h2.5v29h-2.5c-.41 0-.75.34-.75.75s.34.75.75.75H12c4.09 0 9.01-3.94 11.18-9.21h3.83c.2 5.38 2.54 8.45 6.48 8.45 3.9 0 5.62-3.4 5.69-3.54.18-.37.03-.82-.34-1a.748.748 0 0 0-1 .34c-.06.11-1.39 2.71-4.35 2.71-3.83 0-4.86-3.61-4.99-6.95h10.74c.41 0 .75-.34.75-.75v-.01l.01-.02Zm-27.25 8.42V9.55c4.23.6 10.06 6.05 10.06 13.15v2.59c0 6.88-5.81 12.53-10.06 13.15ZM33.5 22.29c3.85 0 4.87 3.65 4.99 7h-9.98c.12-3.35 1.14-7 4.99-7Z",
    fill: "currentColor"
  }));
}

export { SvgDexpanthenolGlyphSecondary as default };
